module.exports = __webpack_public_path__ + "img/1-1.dc6aaef6.png";